import { FigmaNodeReference, FigmaNodeRenderedImage, FigmaNodeRenderError, FigmaNodeRenderFormat, FigmaNodeRenderState, } from "@supernova-studio/model";
import { DTOFigmaNodeOrigin } from "./figma-node";
import { z } from "zod";
export const DTOFigmaNodeDataV2 = z.object({
    sceneNodeId: z.string(),
    format: FigmaNodeRenderFormat,
    scale: z.number().optional(),
    renderState: FigmaNodeRenderState,
    renderedImage: FigmaNodeRenderedImage.optional(),
    renderError: FigmaNodeRenderError.optional(),
    hasSource: z.boolean(),
});
export const DTOFigmaNodeV2 = FigmaNodeReference.omit({
    data: true,
    origin: true,
}).extend({
    data: DTOFigmaNodeDataV2,
    origin: DTOFigmaNodeOrigin,
});
